import Base from 'app/views/base';

import ItemView from '../item';
import tmpl from './template';

export class Heading {
  constructor(options) {
    const {
      property,
      display,
      xsSize,
      smSize,
      xsHidden = false,
      wrapperClass,
      onClick,
      text,
      subView,
    } = options;

    this.property = property;
    this.display = display;
    this.xsSize = xsSize;
    this.smSize = smSize;
    this.xsHidden = xsHidden;
    this.wrapperClass = wrapperClass;
    this.onClick = onClick;
    this.text = text;
    this.subView = subView;
  }

  computeClass(model) {
    const classes = [];

    if (this.xsHidden) {
      classes.push('hidden-xs');
    } else {
      classes.push(`col-xs-${this.xsSize}`);
    }

    classes.push(`col-sm-${this.smSize}`);


    if (this.wrapperClass) {
      if (typeof this.wrapperClass === 'function') {
        classes.push(this.wrapperClass(model));
      } else {
        classes.push(this.wrapperClass);
      }
    }

    return classes.join(' ');
  }
}

export const List = Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #get_next_page': 'getNextPage',
  },

  initialize({
    noResultsMessage = 'No items found.',
    headings = [],
    showDetails = false,
  }) {
    this.noResultsMessage = noResultsMessage;
    this.headings = headings;
    this.uid = parseInt(Math.random() * 100000, 10);
    this.showDetails = showDetails;
    this.fetchError = undefined;

    this.listenTo(this.collection, 'request', () => this.fetchError = undefined);
    this.listenTo(this.collection, 'error', () => this.fetchError = true);
    this.listenTo(this.collection, 'sync error', this.render);

    // this check can be removed once all list pages use a PageableBase
    if (this.collection.getFirstPage) this.collection.getFirstPage();
  },

  beforeRender() {
    this.collection.each((model) => {
      const id = this.computeId(model.id || model.cid);

      this.addSubview(
        id,
        `#${id}`,
        new ItemView({
          model,
          headings: this.headings,
          showDetails: this.showDetails,
        }),
      );
    });
  },

  computeId(id) {
    return `${this.uid}-model-${id}`;
  },

  context() {
    return {
      headings: this.headings,
      firstFetchSuccess: this.collection.firstFetchSuccess,
      collection: this.collection.fullCollection || this.collection,
      computeId: this.computeId,
      uid: this.uid,
      noResultsMessage: this.noResultsMessage,
      hasNextPage: this.collection.hasNextPage ? this.collection.hasNextPage() : undefined,
      fetchError: this.fetchError,
    };
  },

  getNextPage() {
    // Only works with collections that are an instance of backbone.paginator
    this.collection.getNextPage();
  },
});



// WEBPACK FOOTER //
// ./app/components/list/list/index.js